var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconSidebarInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70959 0.9375V2.78592M12 0.9375V2.78592M17.2904 0.9375V2.78592M6.70959 21.2141V23.0625M12 21.2141V23.0625M17.2904 21.2141V23.0625M23.0625 6.70959H21.2141M23.0625 12H21.2141M2.78592 6.70959H0.9375M2.78592 12H0.9375M2.78592 17.2904H0.9375M7.30378 15.3497L9.78272 8.84091C9.83339 8.71706 10.0087 8.71688 10.0596 8.84063L12.516 15.3497M8.07689 13.7287H11.7554M16.3212 8.65031V15.252",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 14.5881V4.7122C22.1 3.15891 20.8408 1.8997 19.2875 1.8997H4.71191C3.15862 1.8997 1.89941 3.15891 1.89941 4.7122V19.2878C1.89941 20.8411 3.15862 22.1003 4.71191 22.1003H19.2875C20.8408 22.1003 22.1 20.8411 22.1 19.2878V19.2756",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconSidebarInactive);
export default __webpack_public_path__ + "static/media/ai_icon_sidebar_inactive.97f677fbcce1e2bd7706cbc2704b6a77.svg";
export { ForwardRef as ReactComponent };